import axios from 'axios';
import { getApiUrl } from '../../../config/api';
import { utils, writeFile } from 'xlsx';

export default class MenuTableView4Controller {
  constructor() {
    this.menusList = [];
    this.selectedMenuToDelete = null;
    this.isLoading = false;
    this.currentError = null;
    
    // Configuración de columnas para vue-good-table
    this.columns = [
      {
        label: 'ID',
        field: 'Menu_id',
        type: 'number',
        width: '70px',
        sortable: true
      },
      {
        label: 'Título',
        field: 'Titulo',
        sortable: true,
        filterOptions: {
          enabled: true,
          placeholder: 'Buscar título'
        }
      },
      {
        label: 'Descripción',
        field: 'Descripcion',
        sortable: true
      },
      {
        label: 'Enlace',
        field: 'Enlace',
        sortable: true
      },
      {
        label: 'Ventana',
        field: 'Ventana',
        sortable: true
      },
      {
        label: 'Imagen',
        field: 'Imagen',
        sortable: false,
        width: '80px'
      },
      {
        label: 'Activo',
        field: 'Es_activo',
        sortable: true,
        width: '80px',
        filterOptions: {
          enabled: true,
          filterDropdownItems: [
            { value: true, text: 'Activo' },
            { value: false, text: 'Inactivo' }
          ]
        }
      },
      {
        label: 'Es Top',
        field: 'Es_top',
        sortable: true,
        width: '80px'
      },
      {
        label: 'Orden',
        field: 'Orden',
        type: 'number',
        sortable: true,
        width: '80px'
      },
      {
        label: 'Grupo',
        field: 'Grupo',
        type: 'number',
        sortable: true,
        width: '80px'
      },
      {
        label: 'Menú Padre',
        field: 'Menu_id_padre',
        type: 'number',
        sortable: true,
        width: '100px'
      },
      {
        label: 'Acciones',
        field: 'actions',
        sortable: false,
        width: '120px'
      }
    ];
  }

  /**
   * Inicializa el controlador cargando los menús
   */
  async initialize() {
    await this.loadMenus();
  }

  /**
   * Carga la lista de menús desde la API
   */
  async loadMenus() {
    try {
      this.isLoading = true;
      this.currentError = null;
      
      const response = await axios.post(getApiUrl('/api/Menu/listar'));
      
      if (response.data && response.data.OData) {
        this.menusList = response.data.OData;
      } else {
        this.menusList = [];
      }
    } catch (error) {
      console.error('Error al cargar menús:', error);
      this.currentError = 'No se pudieron cargar los menús. Por favor, intente nuevamente.';
      this.menusList = [];
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Establece el menú que se va a eliminar
   * @param {Object} menu - El menú a eliminar
   */
  setMenuToDelete(menu) {
    this.selectedMenuToDelete = menu;
  }

  /**
   * Elimina el menú seleccionado
   */
  async deleteMenu() {
    if (!this.selectedMenuToDelete) {
      throw new Error('No hay menú seleccionado para eliminar');
    }

    try {
      const response = await axios.post(
        getApiUrl('/api/Menu/borrar'), 
        this.selectedMenuToDelete.Menu_id
      );
      
      // Recargar la lista después de eliminar
      await this.loadMenus();
      
      // Limpiar la selección
      this.selectedMenuToDelete = null;
      
      return response.data;
    } catch (error) {
      console.error('Error al eliminar menú:', error);
      throw new Error('No se pudo eliminar el menú. Por favor, intente nuevamente.');
    }
  }

  /**
   * Exporta los menús a un archivo Excel
   */
  exportToExcel() {
    try {
      // Crear una copia de los datos sin la columna de acciones
      const exportData = this.menusList.map(menu => {
        const menuCopy = { ...menu };
        // Convertir booleanos a texto para mejor legibilidad en Excel
        menuCopy.Es_activo = menuCopy.Es_activo ? 'Sí' : 'No';
        menuCopy.Es_top = menuCopy.Es_top ? 'Sí' : 'No';
        // Eliminar campos que no queremos exportar
        delete menuCopy.actions;
        return menuCopy;
      });
      
      // Crear libro de Excel
      const worksheet = utils.json_to_sheet(exportData);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, 'Menús');
      
      // Generar archivo Excel y descargarlo
      writeFile(workbook, 'menus_export.xlsx');
    } catch (error) {
      console.error('Error al exportar a Excel:', error);
      throw new Error('Error al exportar los datos a Excel.');
    }
  }

  /**
   * Limpia la selección del menú a eliminar
   */
  clearMenuToDelete() {
    this.selectedMenuToDelete = null;
  }

  /**
   * Resetea el estado del controlador
   */
  reset() {
    this.menusList = [];
    this.selectedMenuToDelete = null;
    this.isLoading = false;
    this.currentError = null;
  }
}